module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABA0lEQVRoQ+3ZTQoDIQyG4XiytsfJXKK9hce1WLCLgcGo+fmEcS34ProKJtp8pc376QZ4vmDO+UlEb2Z+tXO3eIEWTkQVQMz874YGnMPbrcMDrsLhAb1wWIA0HA4wGg4DmA0PB6yGhwG0wt0B2uFuAKtwc4B1uBnAK1wd4B2uBogKXwZEh08DUMKHAWjhYgBqeBeAHi4ClFI+KaWH57A+elZ3pKwvgQzpAtqNoELEAFTIMAANMg1AgSwDoiFqgCiIOsAbYgbwgpgDrCFuACuIO0AbEgbQgoQDViEwgFkIHGAUAguQQuABPcg2gCvIdoAz5DiO339xXdD/xJJh/wZIbslyzxfbZecxdf0/JQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-triangle.png
// module id = vmWX
// module chunks = 0